module.exports = __webpack_public_path__ + "static/media/placeholder.05e3ab33.svg";